<template>
  <section id="about">
    <AboutDesktop v-if="!isMobile" />
    <AboutMobile v-else />
  </section>
</template>





<script>
import { mapGetters } from "vuex";
import AboutDesktop from "./AboutDesktop.vue";
import AboutMobile from "./AboutMobile.vue";

export default {
  name: "AboutSection",
  components: {
    AboutDesktop,
    AboutMobile,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isMobile"]),
  },
};
</script>


